import { render } from "./Page.vue?vue&type=template&id=2996aa42"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=2996aa42&lang=scss"

import exportComponent from "/Users/bapman/Sites/telemac-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__